// src/features/sso-auth/components/LoginPage.tsx
import React, { useEffect, useState } from 'react';
import { useAuthStore } from '../store/authStore';
import { AuthService } from '../services/authService';
import Loading from './Loading';
import { Button } from '@ab-inbev-maz/compass';

import logo from '../../../assets/images/logo_smart_comms.svg';
import logoAbInbev from '../../../assets/images/logo_abinbev.png';

const LoginPage: React.FC = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  const [isInitiatingLogin, setIsInitiatingLogin] = useState(false);

  useEffect(() => {
    // If already authenticated, redirect to home
    if (isAuthenticated) {
      window.location.href = '/';
    }
  }, [isAuthenticated]);

  const handleLogin = async () => {
    setIsInitiatingLogin(true);

    try {
      const loginResponse = await AuthService.initiateLogin();
      console.log(loginResponse);
      // Redirect to Microsoft OAuth URL
      window.location.href = loginResponse.url;
    } catch (err) {
      console.error('Login error:', err);
    } finally {
      setIsInitiatingLogin(false);
    }
  };

  if (isInitiatingLogin) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#222222] to-[#868686] py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-sm w-full space-y-8 bg-white p-8 rounded-3xl shadow-lg">
          <img src={logoAbInbev} className="w-28 mb-4" alt="Logo Ab Inbev" />
          <Loading message="Esto solo va tomar un momento, estamos validados tus datos." />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#222222] to-[#868686] py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-sm w-full space-y-8 bg-white p-8 rounded-3xl shadow-lg">
        <img src={logoAbInbev} className="w-28 mb-4" alt="Logo Ab Inbev" />
        <img src={logo} className="w-48 mx-auto mt-6 mb-4" alt="Logo" />
        <h2 className="text-xl font-bold text-black mb-2">¡Hola, es un gusto tenerte aquí!</h2>
        <p className="text-gray-600 mb-4">Accede a la plataforma con los datos de tu cuenta.</p>
        <small className="text-xs text-gray-900 mb-1">¿Tienes correo corporativo?</small>
        <Button className="w-full mt-4 mb-4" onClick={handleLogin}>
          <svg
            width="26"
            height="24"
            viewBox="0 0 26 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.9822 0.000976562C13.7408 0.000976562 14.4831 0.0719063 15.2029 0.206055C14.7261 6.42153 9.53174 11.3163 3.19409 11.3164C2.43543 11.3164 1.69315 11.2455 0.973389 11.1113C1.4502 4.89593 6.64458 0.00107148 12.9822 0.000976562Z"
              fill="url(#paint0_linear_4029_26514)"
            />
            <path
              d="M1.12671 14.1826C6.37703 14.8229 10.5832 18.8418 11.5076 23.999C6.25737 23.358 2.05032 19.3403 1.12671 14.1826Z"
              fill="url(#paint1_radial_4029_26514)"
            />
            <path
              d="M21.0747 3.125C23.5023 5.3285 25.0269 8.50912 25.0269 12.0459C25.0267 17.6912 21.1424 22.4267 15.9009 23.7314C14.0545 21.4486 12.9478 18.5427 12.9478 15.3779C12.9478 9.86841 16.2992 5.14135 21.0747 3.125Z"
              fill="#EBD60C"
            />
            <defs>
              <linearGradient
                id="paint0_linear_4029_26514"
                x1="1.20103"
                y1="6.3822"
                x2="13.562"
                y2="6.3822"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#CEA127" />
                <stop offset="1" stopColor="#EBD60C" />
              </linearGradient>
              <radialGradient
                id="paint1_radial_4029_26514"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(1.20098 19.8659) scale(8.42683 8.91041)"
              >
                <stop stopColor="#CEA127" />
                <stop offset="1" stopColor="#EBD60C" />
              </radialGradient>
            </defs>
          </svg>
          Ingresa por Ab-Inbev
        </Button>

      </div>
    </div>
  );
};

export default LoginPage;
